// src/components/FullPageLoader.js
import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
import './FullPageLoader.css';

const FullPageLoader = () => {
    return (
        <div className="loader-container">
            <ThreeDots color="#DB9E30" height={100} width={100} />
        </div>
    );
};

export default FullPageLoader;
